import type { RuleMap } from "@certa/studio-core";
import { RuleType } from "@certa/studio-core";
import type {
  ConditionMap,
  ConditionGroupMap
} from "../components/RulesUI/Constraints/constraints.types";
import { deserialize } from "../components/RulesUI/Constraints/constraints.utils";

/**

  const isConditionLessConstraint =
    constraintType === ConstraintTypes.REDUCTION_CONSTRAINTS ||
    constraintType === ConstraintTypes.DOCUMENT_INHERITANCE;

  const isConditionOptionalConstraint =
    constraintType === ConstraintTypes.NOTIFICATION_CONSTRAINTS;

 */

const isConditionLess = (ruleType: RuleType) => {
  return (
    ruleType === RuleType.AttachmentInheritance ||
    ruleType === RuleType.DataReduction
  );
};
/**
 * What we want to here is, take in the raw rules and:
 * 1. Separate them first by different actions
 * 2. Then for each different rule-set (with unique set of actions),
 *    we transform conditions from raw type to internal type
 * 3.
 */
export const getRulesModel = (
  ruleSet: any,
  ruleType: RuleType,
  { processId, targetFieldTag }: { processId: string; targetFieldTag?: string }
) => {
  const ruleMap = deserialize(
    ruleSet,
    isConditionLess(ruleType),
    processId,
    ruleType,
    targetFieldTag
  ); // this is from Constraints UI v1
  const newRuleMap: RuleMap = {};
  let aggregatedConditionMap: ConditionMap = {};
  let aggregatedConditionGroupMap: ConditionGroupMap = {};
  Object.values(ruleMap).forEach(rule => {
    const { conditions, groups, ...otherProps } = rule;

    aggregatedConditionMap = { ...aggregatedConditionMap, ...conditions };
    aggregatedConditionGroupMap = { ...aggregatedConditionGroupMap, ...groups };

    newRuleMap[rule.id] = {
      ruleType,
      ...otherProps
    };
    if (targetFieldTag) newRuleMap[rule.id].__targetFieldTag = targetFieldTag;
  });

  return {
    ruleMap: newRuleMap,
    conditionMap: aggregatedConditionMap,
    conditionGroupMap: aggregatedConditionGroupMap
  };
};
